import '@design-system/web-components/stamp-provider';
import '@design-system/web-components/container';
import '@design-system/web-components/text';
import '@design-system/web-components/table';
import '@design-system/web-components/flex';
import '@design-system/web-components/alert';
import '@design-system/web-components/accordion';
import '@design-system/web-components/text-field';
import '@design-system/web-components/checkbox-field';
import '@design-system/web-components/button';

import './styles.scss';

// Start the UDL
import UniversalDataLayer, { FormattedConsoleLogger } from "@cpt/universal-datalayer";
const universalDataLayer = new UniversalDataLayer({
    logger: new FormattedConsoleLogger()
});

universalDataLayer.collect();

function displaySessionId(sessionInfo) {
  const sessionIdContainer = document.getElementById('sessionId');

  if (sessionIdContainer && sessionInfo?.sessionId) {
    sessionIdContainer.innerText = sessionInfo.sessionId;
  }
}

function displayUserId(sessionInfo) {
  const userIdContainer = document.getElementById('userId');

  if (userIdContainer && sessionInfo?.userId) {
    userIdContainer.innerText = sessionInfo.userId;
  }
}

window.addEventListener('postnl:webchat:ready', (evt) => {
  const sessionInfo = evt.detail;
  console.log('WebChat is ready', sessionInfo);

  displaySessionId(sessionInfo);
  displayUserId(sessionInfo);
});

// Update web component settings from the developer settings panel
window.addEventListener('load', () => {
    const webchatComponent = document.querySelector('swp-chatbot-window');
    const featureFlowInput = document.getElementById('featureFlowInput');
    const cognigyConfigUrlInput = document.getElementById('cognigyConfigUrlInput');
    const chatbotEndpointNameInput = document.getElementById('chatbotEndpointNameInput');
    const environmentInput = document.getElementById('environmentInput');
    const hideBubbleWhenClosedInput = document.getElementById('hideBubbleWhenClosedInput');
    const updateWebchatButton = document.getElementById('updateWebchatButton');

    if (
      webchatComponent &&
      featureFlowInput &&
      cognigyConfigUrlInput &&
      chatbotEndpointNameInput &&
      environmentInput &&
      hideBubbleWhenClosedInput &&
      updateWebchatButton
    ) {
      featureFlowInput.value = webchatComponent.featureFlow ?? '';
      cognigyConfigUrlInput.value = webchatComponent.cognigyConfigUrl ?? '';
      chatbotEndpointNameInput.value = webchatComponent.chatbotEndpointName ?? '';
      environmentInput.value = webchatComponent.environment ?? '';
      hideBubbleWhenClosedInput.checked = webchatComponent.hideBubbleWhenClosed ?? false;
      updateWebchatButton.onclick = () => {
        window.dispatchEvent(new CustomEvent('postnl:webchat:settings:update', {
          detail: {
            featureFlow: featureFlowInput.value,
            cognigyConfigUrl: cognigyConfigUrlInput.value,
            chatbotEndpointName: chatbotEndpointNameInput.value,
            environment: environmentInput.value,
            hideBubbleWhenClosed: hideBubbleWhenClosedInput.checked
          }
        }));
      };
    }
  });
